import React, { useState, useRef, useEffect } from 'react';
export const Chatbox = () => {
  const [input, setInput] = useState('');
  const [messages, setMessages] = useState([]);
  const chatEndRef = useRef(null);
  const botAnswers = {
  // Greetings
  "hi": "Hello 🙂 How can I help you?",
  "hello": "Hi there! How can I assist you today?",
  "hey": "Hey! 😊 Ask me anything about the college.",
  "whats up": "Not much! How can I help you?",
  "good morning": "Good morning! 🌞 Hope you have a great day.",
  "good afternoon": "Good afternoon! 😊",
  "good evening": "Good evening! 🌆 How can I help you?",
  "good night": "Good night! 🌙 Sleep well.",

  // Small Talk
  "how are you": "I'm doing great! 😊 What about you?",
  "who are you": "I'm the CUPB Student Chatbot here to assist you! 🤖",
  "how r you": "I'm fine, thanks for asking! 👍",
  "what about you": "I'm always good and ready to help 😄",
  "i am fine": "That's good to hear! 😊",
  "fine": "Nice 👍 How can I help you?",
  "ok": "Alright 😊",
  "thank you": "You're welcome! 😄",
  "thanks": "My pleasure! 😊",
  "thanku": "You're always welcome 👍",
  "my pleasure": "😊",

  // Ending Conversation
  "bye": "Bye! 👋 Have a great day!",
  "goodbye": "Goodbye! 😊 Take care.",
  "see you": "See you soon! 👋",
  "see u": "Sure! 😊",
  "exit": "Okay! Bye 👋",

  // General Information
  "college name": "Our college is Central University of Punjab.",
  "college location": "The college is located in Ghudda village, Bathinda, Punjab.",
  "college type": "This is a government university.",
  "accreditation": "The college is NAAC accredited with A grade.",

  // Timings
  "college timing": "College timing is 9 AM to 5 PM.",
  "class timing": "Classes run from 9 AM to 5 PM.",
  "lunch break": "Lunch break is from 1 PM to 2 PM.",
  "working days": "College operates from Monday to Friday.",

  // Exams
  "exam schedule": `You can check the exam schedule on the official website:
<a href="https://cup.edu.in/" target="_blank">Visit Fees Page</a>`,
  "exam timing": "Exams are conducted usually from 10 AM to 12:30 PM.",
  "mid sem exams": "Mid semester exams are usuallyheld in October.",
  "end sem exams": "End semester exams are usually held in December.",
  "result date": "Results are usually declared within 45 days.",

  // Attendance
  "attendance": "Minimum 75% attendance is required.",
  "attendance rule": "Students must maintain at least 75% attendance.",
  "low attendance": "Low attendance may lead to exam detention.",

  // Courses
  "courses offered": "We offer UG and PG courses in various disciplines.",
  "btech branches": "BTech branches include CSE only.",
  "semester system": "The college follows a semester system.",
  "btech cse syllabus": `You can download the BTech CSE syllabus here:
<a href="/btech_cse_syllabus.pdf" target="_blank">📄B.Tech CSE Syllabus </a>`,

  // Faculty
  "hod cse": "The HOD of CSE department is Prof. Amandeep Kaur.",
  "faculty of cse": "Dr. Surinder khurana, Dr. Parneet kaur, Dr. Anam Bansal, Dr. Anandika Sharma, Dr. Amandeep kaur, Dr. Meenakshi Mittal, Dr. Priyavrat Chauhan, Dr. Satwinder singh,",

  // Facilities
  "library": "Yes, the college has a central library.",
  "wifi": "Yes, Wi-Fi is available on campus.",
  "labs": "All departments have well-equipped labs.",
  "canteen": "Two canteens and cafes are available on campus.",

  // Hostel & Transport
  "hostel": "Hostel facility is available for students.",
  "boys hostel": "Separate hostel is available for boys.",
  "girls hostel": "Separate hostel is available for girls.",
  "transport": "College bus facility is available.",

  // Fees & Scholarships
  "fees": `You can check the complete fee structure on the official website:
<a href="https://cup.edu.in/cup_student-corner.php/fee.php" target="_blank">Visit Fees Page</a>`
,

  // Placements
  "placements": "The college has an active placement cell.",
  "companies": "Top companies visit the campus for placements.",
  "internships": "Internship assistance is provided to students.",
  "highest package": "The highest package offered is 8 LPA.",

  // Student Life
  "clubs": "Technical and cultural clubs are active in the college.",
  "sports": "Sports facilities are available for students.",
  "fest": "Annual technical and cultural fests are organized.",

  // Help & Contact
  "office contact": "You can contact the office at 0123-456789.",
  "email": "College email is cup.edu.in",
  "admin office": "Admin office is located in the main building."
};
  useEffect(() => {
    chatEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const Sendbutton = () => {
    if (!input.trim()) return;

    const userInput = input;
    setMessages(prev => [...prev, { sender: 'user', text: userInput }]);

    setTimeout(() => {
      const lowerInput = userInput.toLowerCase();
      const matchedKey = Object.keys(botAnswers).find(key =>
        lowerInput.includes(key)
      );
      const reply = matchedKey
        ? botAnswers[matchedKey]
        :`I'm sorry, I am not updated on this info yet. Please visit the official website or contact the admin office for more details.
<a href="https://cup.edu.in" target="_blank">Visit Official Page</a>`

      setMessages(prev => [...prev, { sender: 'bot', text: reply }]);
    }, 300);

    setInput('');
  };

  return (
    <div
      className="card mx-auto "
      style={{
        width: "100%",
        maxWidth: "800px",   
        height: "100vh",      
        backgroundImage: "linear-gradient(to bottom right, #e3c9f9ff, #d5f1f8ff)",
        border: "1px solid #eceaecff"
      }}
    >
      <div
        style={{
          backgroundImage: "linear-gradient(to bottom right, #4e0241ff, #01374dff)",
          color: "#fff",
          padding: "15px",
          textAlign: "center",
          fontSize: "22px",
          fontWeight: "bold",

        }}
      >
        <img
          src="/image.png"
          alt="Logo"
          style={{ width: "40px", height: "40px", marginRight: "10px" }}
        />
        CUPB Student Chatbot
      </div>
      <div
        className="card-body"
        style={{
          overflowY: "auto",
          flex: 1
        }}
      >
        {messages.map((msg, idx) => (
          <div
            key={idx}
            className={`d-flex ${
              msg.sender === 'user'
                ? 'justify-content-end'
                : 'justify-content-start'
            }`}
          >
            <div
              style={{
                marginTop: "10px",
                backgroundImage:
                  "linear-gradient(to bottom right, #4e0241ff, #01374dff)",
                color: "#fff",
                borderRadius: "10px",
                padding: "10px",
                maxWidth: "75%"
              }}
              ref={idx === messages.length - 1 ? chatEndRef : null}
              dangerouslySetInnerHTML={msg.sender === 'bot' ? { __html: msg.text } : undefined}
            >
             {msg.sender === 'user' ? msg.text : null}
            </div>
          </div>
        ))}
      </div>
      <div
        className="card-footer d-flex"
        style={{
          backgroundImage:
            "linear-gradient(to bottom right, #4e0241ff, #01374dff)"
        }}
      >
        <input
          type="text"
          className="form-control me-2"
          placeholder="Type your message..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && Sendbutton()}
        />
        <button
  type="button"
  className="btn d-flex align-items-center justify-content-center"
  onClick={Sendbutton}
  style={{
    width: "45px",
    height: "45px",
    borderRadius: "50%",
    backgroundImage: "linear-gradient(to bottom right, #9c8b99ff, #9aaab0ff)",
    color: "#032313ff"
  }}
>
  <i className="fa-solid fa-paper-plane"></i>
</button>

      </div>
    </div>
  );
};
